import INTEGRATIONS from './integrations.gql';
import ME from './me.gql';
import BANK_ACCOUNTS from './bankAccounts.gql';

export {
  INTEGRATIONS,
  ME,
  BANK_ACCOUNTS,
};
